/**
 * This file includes polyfills needed by Angular and is loaded before the app.
 * You can add your own extra polyfills to this file.
 *
 * This file is divided into 2 sections:
 *   1. Browser polyfills. These are applied before loading ZoneJS and are sorted by browsers.
 *   2. Application imports. Files imported after ZoneJS that should be loaded before your main
 *      file.
 *
 * The current setup is for so-called "evergreen" browsers; the last versions of browsers that
 * automatically update themselves. This includes recent versions of Safari, Chrome (including
 * Opera), Edge on the desktop, and iOS and Chrome on mobile.
 *
 * Learn more in https://angular.io/guide/browser-support
 */

/***************************************************************************************************
 * BROWSER POLYFILLS
 */

/**
 * By default, zone.js will patch all possible macroTask and DomEvents
 * user can disable parts of macroTask/DomEvents patch by setting following flags
 * because those flags need to be set before `zone.js` being loaded, and webpack
 * will put import in the top of bundle, so user need to create a separate file
 * in this directory (for example: zone-flags.ts), and put the following flags
 * into that file, and then add the following code before importing zone.js.
 * import './zone-flags';
 *
 * The flags allowed in zone-flags.ts are listed here.
 *
 * The following flags will work for all browsers.
 *
 * (window as any).__Zone_disable_requestAnimationFrame = true; // disable patch requestAnimationFrame
 * (window as any).__Zone_disable_on_property = true; // disable patch onProperty such as onclick
 * (window as any).__zone_symbol__UNPATCHED_EVENTS = ['scroll', 'mousemove']; // disable patch specified eventNames
 *
 *  in IE/Edge developer tools, the addEventListener will also be wrapped by zone.js
 *  with the following flag, it will bypass `zone.js` patch for IE/Edge
 *
 *  (window as any).__Zone_enable_cross_context_check = true;
 *
 */

/***************************************************************************************************
 * Zone JS is required by default for Angular itself.
 */
import './zone-flags'; // Import zone flags before zone.js to prevent conflicts with Dynatrace
import 'zone.js'; // Included with Angular CLI.

// Protection Zone.js simplifiée
(function simpleZoneProtection() {
  console.log('[Polyfills] 🛡️ Protection Zone.js simplifiée activée');

  // Intercepter seulement les erreurs critiques
  const originalOnError = window.onerror;
  window.onerror = function (message: any) {
    if (
      typeof message === 'string' &&
      (message.includes('can not transition to') ||
        message.includes('Cannot assign to read only property'))
    ) {
      return true; // Bloquer ces erreurs spécifiques
    }
    return originalOnError ? originalOnError.apply(this, arguments as any) : false;
  };
})();

/***************************************************************************************************
 * APPLICATION IMPORTS
 */

/* Add global to window, assigning the value of window itself.
 * This fixes a problem with the buffer library (dependency of aws-sdk)
 * because Angular removed global keyword in Angular 6.
 *
 * See: https://github.com/angular/angular-cli/issues/8160
 * And: https://github.com/angular/angular-cli/issues/9827#issuecomment-369578814
 */
/**
 * DYNATRACE INTEGRATION SIMPLIFIÉE
 */
(function loadDynatrace() {
  // DISABLE DYNATRACE FOR DEBUGGING ZONE.JS CONFLICT
  return;
  console.log('[Polyfills] 🚀 Chargement Dynatrace...');

  // Shim Dynatrace
  (window as any).dtrum =
    (window as any).dtrum ||
    function () {
      ((window as any).dtrum.q = (window as any).dtrum.q || []).push(arguments);
    };

  const script = document.createElement('script');
  script.async = true;
  script.src =
    'https://js-cdn.dynatrace.com/jstag/1623d230d17/bf53810kfz/41607f01c4f9a2_complete.js';
  script.crossOrigin = 'anonymous';

  const config = [
    'app=0041607f01c4f9a2',
    'cors=1',
    'featureHash=ICA7NVfqrux',
    'reportUrl=https://bf53810kfz.bf.dynatrace.com/bf',
    'auto=1',
  ].join('|');

  script.setAttribute('data-dtconfig', config);

  script.onload = () => {
    console.log('[Polyfills] ✅ Dynatrace activé');
    if (typeof (window as any).dtrum === 'function') {
      (window as any).dtrum('enable');
    }
  };

  script.onerror = () => {
    console.warn('[Polyfills] ❌ Erreur chargement Dynatrace');
    (window as any).dtrum = () => {};
  };

  document.head.appendChild(script);
})();

/* Add global to window, assigning the value of window itself.
 * This fixes a problem with the buffer library (dependency of aws-sdk)
 * because Angular removed global keyword in Angular 6.
 */
(window as any).global = window;
